/**
 * package: com.inq.flash.messagingframework
 * class: MessageRouter
 * root Object
 * @constructor
 */
com.inq.flash.messagingframework.MessageRouter = function() {
	this.handlers = new com.inq.utils.Dictionary();
};
$hxClasses['com.inq.flash.messagingframework.MessageRouter'] = com.inq.flash.messagingframework.MessageRouter;
/** @private @type {Array} */
com.inq.flash.messagingframework.MessageRouter.__name__ = ["com","inq","flash","messagingframework","MessageRouter"];

/**
 * Mapper between messages and handlers by message type.
 * @param {com.inq.flash.messagingframework.Message} message which needs to be processed.
 */
com.inq.flash.messagingframework.MessageRouter.prototype.processMessage = function (message) {
	try {
		try {
			/* Check a message contains an chatid AND matching with current chat id if not matching discard. If a message doesn't have chatId continue */
			if (message.getProperty('engagementID') && (com.inq.flash.client.control.FlashVars.getChatID() !== message.getProperty('engagementID'))) {
				com.inq.flash.client.control.FlashPeer.logErrorToServer(
					"MessageRouter#processMessage rejects a message. Message info: ["
					+ "chatID: '" + message.getProperty('engagementID') + "', "
					+ "messageType: '" + message.getMessageType() + "' ]. "
					+ "Chat id from FlashVars: " + com.inq.flash.client.control.FlashVars.getChatID()
				);
				return;
			}
		} catch (err) { /* Ignore and Continue */ }

		var handler = this.getHandlerByPrefix(message.getMessageType());
		if (handler) {
			try {
				handler.processMessage(message);
				haxe.Log.trace("handler processed " + message.getMessageType(), { fileName: "MessageRouter.hx", lineNumber: 34, className: "com.inq.flash.messagingframework.MessageRouter", methodName: "processMessage"});
			} catch (e) {
				haxe.Log.trace("handler.processMessage(message) throws " + Std.string(e), { fileName: "MessageRouter.hx", lineNumber: 37, className: "com.inq.flash.messagingframework.MessageRouter", methodName: "processMessage", customParams: ["error"]});
			}
		} else {
			haxe.Log.trace("message has no handler;\n" + "messageType: " + message.getMessageType(),{ fileName : "MessageRouter.hx", lineNumber : 42, className : "com.inq.flash.messagingframework.MessageRouter", methodName : "processMessage", customParams : ["warn"]});
		}
	} catch( e ) {
		haxe.Log.trace("Error: " + Std.string(e),{ fileName : "MessageRouter.hx", lineNumber : 44, className : "com.inq.flash.messagingframework.MessageRouter", methodName : "processMessage", customParams : ["error"]});
	}
};

/**
 * Searches for handler by prefix of message type.
 * @param {String} messageType
 * @returns {com.inq.flash.messagingframework.AbstractMessageHandler} First suitable by prefix handler
 */
com.inq.flash.messagingframework.MessageRouter.prototype.getHandlerByPrefix = function (messageType) {
	/** @type {Array} */
	var keyz = com.inq.utils.Util.fields(this.handlers);
	for (var i = 0; i < keyz.length; i++) {
		/** @type {com.inq.flash.messagingframework.AbstractMessageHandler} */
		var handler = this.handlers[keyz[i]];
		/** @type {string} */
		var handlerMsgType = handler.getMessageType();
		if (messageType.indexOf(handlerMsgType) == 0) {
			return handler;
		}
	}
};

/**
 * registerMessageHandler
 *
 * $type TFun([{ name => messageHandler, t => TInst(com.inq.flash.messagingframework.AbstractMessageHandler,[]), opt => false }],TEnum(Void,[]))
 * public function registerMessageHandler(messageHandler:AbstractMessageHandler):Void
 * @public
 * @this com.inq.flash.messagingframework.MessageRouter
 * @param {com.inq.flash.messagingframework.AbstractMessageHandler}  messageHandler 
 * @return {void}
 */
com.inq.flash.messagingframework.MessageRouter.prototype.registerMessageHandler = function(messageHandler) {
	this.handlers[messageHandler.getMessageType()] = messageHandler;
};

/** @private @type {com.inq.utils.Dictionary} */
com.inq.flash.messagingframework.MessageRouter.prototype.handlers = null;
/** @type {com.inq.flash.messagingframework.MessageRouter} */
com.inq.flash.messagingframework.MessageRouter.prototype.__class__ = com.inq.flash.messagingframework.MessageRouter;
